<template>
  <div>
    <PCNavbar selectIndex="1" isBlue="true" />
    <MobileNavBar :currentActive="0" />
        <NewsDetailsMobile :content="newsContent" :newDet="newDet"/>
    <!-- <CallMe /> -->
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index';
import MobileNavBar from '@/components/navbar/MobileNavBar.vue';
import CallMe from '@/components/callme/index';
import MobileCallme from '@/components/callme/callMeMile.vue';
import NewsDetailsMobile from '@/components/details/NewsDetailsMobile.vue';
import { newGetById } from "@/api/news.js";

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
    NewsDetailsMobile,
  },
  data() {
    return {
      newsTitle: '新闻标题示例',
      newsContent: '这是新闻内容的示例。',
      currentSource: '',
      newDet: {}
    };
  },
  created() {
    this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
  },
  watch: {
    // 监听 URL 的变化
    '$route.fullPath': {
      immediate: true,
      handler() {

        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get('source');
        if (source !== this.currentSource) {
          this.currentSource = source;
          this.getNewDetail();
        }
      },
    },
  },
  methods: {
    getNewDetail() {
            newGetById({ id: this.currentSource }).then((res) => {
        if (res) {
          this.newDet = res.result;
        }
      })
     
    },
  },
};
</script>

<style lang="scss" scoped>
.news-detail {
  padding: 20px;
  h1 {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  p {
    font-size: 1rem;
    line-height: 1.5;
  }
}
</style>
